module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "search",
      "placeholder": "搜索商家、商品名称"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keydown": function($event) {
        return _vm.key($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.keyword != '') ? _c('span', {
    staticClass: "clearbtn",
    on: {
      "click": _vm.clearInput
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.getGoodsSearch()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), (!_vm.showResult) ? _c('div', {
    staticClass: "search-result"
  }, [(_vm.historySearchList.length > 0) ? _c('div', {
    staticClass: "icon icon-hot"
  }, [_vm._v("历史搜索 "), _c('span', {
    staticClass: "icon icon-delete fr",
    on: {
      "click": function($event) {
        return _vm.clearHistory()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.historySearchList.length > 0) ? _c('div', {
    staticClass: "hot-keys"
  }, _vm._l((_vm.historySearchList), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.getGoodsSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon-hot",
    staticStyle: {
      "margin-top": ".4rem",
      "margin-bottom": ".04rem"
    }
  }, [_vm._v("搜索发现")]), _vm._v(" "), (_vm.searchRecom.length > 0) ? _c('div', {
    staticClass: "hot-keys"
  }, _vm._l((_vm.searchRecom), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.getGoodsSearch(item.keyword)
        }
      }
    }, [_vm._v(_vm._s(item.keyword))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shop-head"
  }, _vm._l((_vm.shopRecom), function(item) {
    return _c('div', {
      staticClass: "shop-recom",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.shop_id)
        }
      }
    }, [_c('img', {
      staticClass: "recom-img",
      attrs: {
        "src": item.pic,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "ellipse recom-name"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "recom-type"
    }, [_vm._v(_vm._s(item.type_name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "goods-list search-goods"
  }, [(_vm.showResult) ? _c('div', [(_vm.goodsInfo.length > 0) ? _c('ul', [_vm._l((_vm.goodsInfo), function(item) {
    return _c('li', [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: ({
        backgroundImage: 'url(' + item.pic + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse",
      domProps: {
        "innerHTML": _vm._s(item.shop_name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('span', [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3",
        "padding": "0 0.05rem"
      }
    }, [_vm._v("|")]), _vm._v(" "), (item.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(item.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? _c('span', [_vm._v(_vm._s(item.new_delivery_fee))]) : _c('span', [_vm._v(_vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? [_c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])] : _vm._e(), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()], 2), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title",
      staticStyle: {
        "margin": "0 0 0 .2rem"
      }
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info) ? _c('div', {
      staticClass: "promotion_reduce"
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2) {
      return _c('span', {
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon"
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, _vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.goods_list.length > 0) ? _c('div', {
      staticClass: "related-goods"
    }, [(item.isShowAll) ? _c('div', {
      staticClass: "more-goods"
    }, _vm._l((item.goods_list), function(item2) {
      return _c('a', {
        domProps: {
          "innerHTML": _vm._s(item2.name)
        }
      })
    }), 0) : _c('div', {
      staticClass: "more-goods"
    }, [_c('a', {
      domProps: {
        "innerHTML": _vm._s(item.goods_list[0].name)
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id)
        }
      }
    })]), _vm._v(" "), (item.goods_list.length > 1) ? _c('div', [(item.isShowAll) ? _c('span', {
      staticClass: "shield-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    }, [_vm._v("收起")]) : _c('span', {
      staticClass: "show-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    }, [_vm._v("展开其他" + _vm._s(item.goods_list.length - 1) + "个商品")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), _vm._v(" "), _vm._m(0)], 2) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "end-line"
  }, [_c('span', [_vm._v("- end -")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-01.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0.2rem 0"
    }
  }, [_vm._v("抱歉，未能找到您搜索的商家或商品")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0.2rem 0"
    }
  }, [_vm._v("换个关键词试试吧")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-186642f4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Search.vue
// module id = 416
// module chunks = 7